export { default as reducer } from './adForm.ducks';



// WEBPACK FOOTER //
// ./src/routes/AdForm/index.ts